import { render, staticRenderFns } from "./MetricBase.vue?vue&type=template&id=1a83a415&scoped=true&"
import script from "./MetricBase.vue?vue&type=script&lang=js&"
export * from "./MetricBase.vue?vue&type=script&lang=js&"
import style0 from "./MetricBase.vue?vue&type=style&index=0&id=1a83a415&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a83a415",
  null
  
)

export default component.exports